type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

const sizeClasses: Record<SpinnerSize, string> = {
    xs: 'h-4 w-4',
    sm: 'h-5 w-5',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
};

export function Spinner({
    size = 'md',
    className = '',
}: {
    size?: SpinnerSize;
    className?: string;
}) {
    return (
        <svg
            className={`animate-spin text-muted-foreground ${sizeClasses[size]} ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            role="status"
            aria-label="Loading"
        >
            <circle className="opacity-25 stroke-current" cx="12" cy="12" r="10" strokeWidth="4" />
            <path className="opacity-75 fill-current" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            <title>Loading</title>
        </svg>
    );
}
